import React, { Component, createContext } from "react";
import { db } from "../services/firebase";
import { UserContext } from "./UserProvider";

export const LeaderboardContext = createContext({ users: {} });

class LeaderboardProvider extends Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      users: {},
      solved: {},
      leaderboardLoaded: false,
    };
  }
  componentDidMount() {
    db.collection("leaderboard").onSnapshot((querySnapshot) => {
      querySnapshot.docChanges().forEach((change) => {
        let doc = change.doc;
        let data = doc.data();
        this.setState((state) => {
          state.users[doc.id] = data;
          let uid = this.context.user.uid;
          if (uid === doc.id) {
            let solvedProblems = this.state.users[this.context.user.uid]
              .solvedProblems;
            Object.keys(solvedProblems).forEach((topic) => {
              state.solved[topic] = new Set(
                Object.keys(solvedProblems[topic])
              );
            });
            state.leaderboardLoaded = true;
          }
          return state;
        });
      });
    });
  }

  render() {
    return (
      <LeaderboardContext.Provider value={this.state}>
        {this.props.children}
      </LeaderboardContext.Provider>
    );
  }
}

export default LeaderboardProvider;
